import { useCallback, useEffect, useState } from 'react';

import { useNavigate } from 'react-router';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import {
  clearPathnameFromStorage,
  useGxTokenFromStorage,
  usePathnameFromStorage,
  useTripTokenFromStorage
} from '@/services/storage';
import { resetStatus } from '@/slices/authSlice';

const useOnboarding = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logoExpanded, setLogoExpanded] = useState<boolean>(false);
  const { status } = useAppSelector(state => state.auth);
  const gxToken = useGxTokenFromStorage();
  const tripToken = useTripTokenFromStorage();
  const pathname = usePathnameFromStorage();
  const handleEntrance = useCallback(() => {
    setLogoExpanded(true);
    if (gxToken) {
      if (pathname && pathname !== '/login') {
        clearPathnameFromStorage();
        navigate(pathname);
      } else {
        navigate('/markets');
      }
    }
  }, [gxToken, navigate, pathname]);

  const resetPage = useCallback(() => {
    dispatch(resetStatus());
  }, [dispatch]);

  useEffect(() => {
    resetPage();
    handleEntrance();
    return () => {
      resetPage();
    };
  }, [handleEntrance, resetPage, tripToken]);

  return {
    logoExpanded,
    resetPage,
    status
  };
};

export default useOnboarding;
